<template>
  <header class="rin-header no-print">
    <div class="main-menu">
      <div
        class="top-bar"
        :class="isPartnerShop ? `partnershop-menu` : undefined">
        <div class="grid-x top-menu-container">
          <div
            class="cell"
            :class="isPartnerShop ? `large-5` : `large-5`">
            <!--change back when rethink gone-->
            <ul class="menu top-bar__list">
              <li class="top-bar__list-item less-padding">
                <a
                  id="shopLink"
                  :class="isPartnerShop ? `partnershop-link` : undefined"
                  data-cy="header-shop-dropdown"
                  data-toggle="menuShopDropdown">
                  <div
                    v-if="isPartnerShop"
                    class="partnershop-menuimage ps-image"
                    :style="{ backgroundImage: `url(${partnerShopInformation.image})`, backgroundPosition: 'center center', backgroundSize: '35px' }">
                  </div>
                  <span
                    v-if="isPartnerShop"
                    class="partnershop-menutext">
                    {{ vueHeader.shopFromText }}
                    <br />
                    {{ partnerDisplayName }}
                  </span>
                  <span v-if="!isPartnerShop">Shop</span>
                </a>
              </li>
              <li class="top-bar__list-item less-padding">
                <a
                  id="soNewLink"
                  data-toggle="menuSoNewDropdown">
                  <span>So New</span>
                  <span
                    v-if="newNewsAmount > 0 && partnerStatus"
                    class="green-dot"></span>
                </a>
              </li>
              <li class="top-bar__list-item less-padding">
                <a
                  id="corporateLink"
                  data-toggle="menuCorporateDropdown">
                  <span>Corporate</span>
                </a>
              </li>
              <li class="top-bar__list-item less-padding">
                <a
                  :href="`/rethink?lang=${vueHeader.shopLanguageCode}`">
                  <span style="background-color: #e6ff00;">RE*THINK</span>
                </a>
              </li>
            </ul>
          </div>
          <div
            class="cell menu-logo"
            :class="isPartnerShop ? `large-2` : `large-2`">
            <!--change back when rethink gone-->
            <a :href="`/?lang=${vueHeader.shopLanguageCode}`">
              <img
                v-if="!isPartnerShop"
                alt="Ringana Logo"
                :src="vueHeader.headerLogoUrl" />
              <img
                v-if="isPartnerShop"
                alt="Ringana Logo Partnershop"
                :src="vueHeader.headerLogoUrlPartner" />
            </a>
          </div>
          <div class="large-1 cell"></div>  <!--change back when rethink gone-->
          <div class="large-4 cell">
            <ul class="menu align-right top-bar__list">
              <li
                v-if="!loggedIn"
                class="menu-login top-bar__list-item"
                data-cy="login-link-desktop"
                v-html="vueHeader.loginHtml">
              </li>
              <li
                v-if="loggedIn"
                class="menu-customer top-bar__list-item">
                <a
                  id="cnMenuLink"
                  data-cy="hello-user-desktop"
                  @mouseover="showCustomerMenu">
                  {{ loggedInName(user) }}
                </a>
              </li>
              <li class="switches top-bar__list-item">
                <a
                  v-if="vueHeader.shopLanguageCode"
                  class="language-switch switches__element"
                  data-toggle="menuLanguageSwitch">
                  <span>{{ vueHeader.shopLanguageCode }}</span>
                </a>
                <a
                  class="currency-switch switches__element"
                  data-toggle="menuCurrencySwitch">
                  <span>{{ selectedCurrency }}</span>
                </a>
                <!-- language-switch-->
                <div
                  id="menuLanguageSwitch"
                  class="dropdown-pane main-menu-switch"
                  data-auto-focus="false"
                  data-dropdown
                  data-hover="true"
                  data-hover-pane="true">
                  <ul class="vertical-menu ">
                    <template v-for="language in languages">
                      <template v-if="language !== vueHeader.shopLanguageCode">
                        <li
                          :key="language.code"
                          class="category">
                          <a @click.prevent.stop="setLanguage(language)">
                            <span>{{ language.code }}</span>
                          </a>
                        </li>
                      </template>
                    </template>
                  </ul>
                </div>
                <!-- /language-switch-->
                <!-- currency switch-->
                <div
                  id="menuCurrencySwitch"
                  class="dropdown-pane main-menu-switch"
                  data-auto-focus="false"
                  data-dropdown
                  data-hover="true"
                  data-hover-pane="true">
                  <ul class="desktop-currency-switch-menu vertical-menu">
                    <li
                      v-for="currency in currencyList"
                      :key="currency.iso"
                      class="category">
                      <span
                        class="desktop-currency-link rin-header__currency"
                        @click.prevent="setSelectedCurrency(currency.iso)">{{ currency.iso }}</span>
                    </li>
                  </ul>
                </div>
                <!--/currency switch-->
              </li>
              <!-- click listener for the search lives in ringana.js -->
              <li class="menu-search top-bar__list-item">
                <span
                  class="menu-search__search_icon"
                  @click="toggleSearchbox">
                  <img
                    :alt="vueHeader.searchAlt"
                    :src="icons.searchIcon" />
                </span>
              </li>
              <li class="top-bar__list-item">
                <a
                  data-cy="header-cart-icon"
                  :href="vueHeader.shopCartLink">
                  <img
                    :alt="vueHeader.cartAlt"
                    class="cartIcon"
                    :src="icons.cartIcon" />
                  <span class="basket-item-count">
                    <span class="value">{{ cartItemAmount }}</span>
                  </span>
                </a>
              </li>
              <li class="top-bar__list-item">
                <a
                  class="menu-dashboard"
                  :href="vueHeader.dashboardUrl">
                  <img
                    v-if="partnerStatus"
                    alt="Dashboard"
                    class="dashboardIcon"
                    :src="icons.dashboard" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        id="menuShopDropdown"
        class="dropdown-pane"
        :class="{'dropdown-pane--partner-site': isPartnerShop }"
        data-auto-focus="false"
        data-dropdown
        data-hover="true"
        data-hover-pane="true">
        <div class="grid-x menu-pane">
          <div class="large-2 cell">
            <ul class="vertical-menu first">
              <li
                v-if="vueHeader.shop.fresh.titleDOM"
                class="category"
                :class="vueHeader.shop.fresh.titleClasses"
                v-html="vueHeader.shop.fresh.titleDOM"></li>
              <template v-if="vueHeader.shop.fresh.entries.length > 0">
                <template v-for="entry of vueHeader.shop.fresh.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      data-cy="header-shop-dropdown-fresh-entry">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
              <li
                v-if="vueHeader.shop.complete.titleDOM"
                class="category"
                :class="vueHeader.shop.complete.titleClasses"
                v-html="vueHeader.shop.complete.titleDOM"></li>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.shop.supplements.titleDOM"
                class="category"
                :class="vueHeader.shop.supplements.titleClasses"
                v-html="vueHeader.shop.supplements.titleDOM"></li>
              <template v-if="vueHeader.shop.supplements.entries.length > 0">
                <template v-for="(entry, index) of vueHeader.shop.supplements.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-1-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
              <li
                v-if="vueHeader.shop.sport.titleDOM"
                class="category"
                :class="vueHeader.shop.sport.titleClasses"
                v-html="vueHeader.shop.sport.titleDOM"></li>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.shop.samples.titleDOM"
                class="category"
                :class="vueHeader.shop.samples.titleClasses"
                v-html="vueHeader.shop.samples.titleDOM"></li>
              <template v-if="vueHeader.shop.sport.entries.length > 0">
                <template v-for="entry of vueHeader.shop.sport.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
              <li
                v-if="vueHeader.shop.offers.titleDOM"
                class="category"
                :class="vueHeader.shop.offers.titleClasses"
                v-html="vueHeader.shop.offers.titleDOM"></li>
              <template v-if="vueHeader.shop.offers.entries.length > 0">
                <template v-for="entry of vueHeader.shop.offers.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
              <li
                v-if="vueHeader.shop.coupons.titleDOM"
                class="category"
                :class="vueHeader.shop.coupons.titleClasses"
                v-html="vueHeader.shop.coupons.titleDOM"></li>
              <template v-if="vueHeader.shop.coupons.entries.length > 0">
                <template v-for="entry of vueHeader.shop.coupons.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
              <li
                v-if="vueHeader.shop.allProducts.titleDOM"
                class="category"
                :class="vueHeader.shop.allProducts.titleClasses"
                v-html="vueHeader.shop.allProducts.titleDOM"></li>
              <template v-if="vueHeader.shop.allProducts.entries.length > 0">
                <template v-for="entry of vueHeader.shop.allProducts.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-6 cell ls0 ls1">
            <div
              v-if="!partnerStatus"
              id="menu-teaser">
              <a :href="vueHeader.shop.teaserLink">
                <img
                  alt="Teaser Image"
                  :src="vueHeader.shop.teaserImage" />
                <div
                  class="menu-teaser-text"
                  v-html="vueHeader.shop.teaserText"></div>
              </a>
            </div>
            <ul
              v-if="partnerStatus"
              class="vertical-menu">
              <li
                v-if="vueHeader.shop.partnerProducts.titleDOM"
                class="category"
                :class="vueHeader.shop.partnerProducts.titleClasses"
                v-html="vueHeader.shop.partnerProducts.titleDOM"></li>
              <template v-if="vueHeader.shop.partnerProducts.entries.length > 0">
                <template v-for="(entry, index) of vueHeader.shop.partnerProducts.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-2-${index}`"
                      class="subcategory"
                      :class="entry.classes"
                      data-cy="header-shop-dropdown-partnershop-entry">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <!--/ menu shop-->
      <div
        id="menuSoNewDropdown"
        class="dropdown-pane"
        :class="{'dropdown-pane--partner-site': isPartnerShop }"
        data-auto-focus="false"
        data-dropdown
        data-hover="true"
        data-hover-pane="true">
        <div class="grid-x menu-pane">
          <div class="large-2 cell">
            <ul class="vertical-menu first">
              <li
                v-if="vueHeader.soNew.news.titleDOM"
                class="category"
                :class="vueHeader.soNew.news.titleClasses"
                @click="removeNewNewsAmount()"
                v-html="vueHeader.soNew.news.titleDOM"></li>
              <span
                v-if="newNewsAmount > 0 && partnerStatus"
                class="new-news-amount">{{ newNewsAmount }}</span>
              <template v-if="vueHeader.soNew.news.entries.length > 0">
                <template v-for="(entryDOM, index) of vueHeader.soNew.news.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`news-entry-${index}`"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entryDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.soNew.blog.titleDOM"
                class="category"
                :class="vueHeader.soNew.blog.titleClasses"
                v-html="vueHeader.soNew.blog.titleDOM"></li>
              <template v-if="vueHeader.soNew.blog.entries.length > 0">
                <template v-for="(entryDOM, index) of vueHeader.soNew.blog.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`blog-entry-${index}`"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entryDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.soNew.media.titleDOM"
                class="category"
                :class="vueHeader.soNew.media.titleClasses"
                v-html="vueHeader.soNew.media.titleDOM"></li>
              <template v-if="vueHeader.soNew.media.entries.length > 0">
                <template v-for="(entryDOM, index) of vueHeader.soNew.media.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`media-entry-${index}`"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entryDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-3 cell">
            <ul class="vertical-menu">
              <li class="category no-sub">
                <a
                  class="nl-menu-register"
                  href="">
                  <img
                    class="letter"
                    :src="icons.letterWhiteIcon" />
                  {{ vueHeader.registerNewsletter }}
                </a>
              </li>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li class="category">
                <div>
                  <a
                    href="https://www.facebook.com/RINGANADE"
                    target="_blank">
                    <img
                      alt="Facebook"
                      :src="icons.facebookIcon" />
                  </a>
                  <a
                    href="https://www.instagram.com/ringana/"
                    target="_blank">
                    <img
                      alt="Instagram"
                      class="last-one"
                      :src="icons.instagramIcon" />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--/ menu So new-->
      <div
        id="menuCorporateDropdown"
        class="dropdown-pane"
        :class="{'dropdown-pane--partner-site': isPartnerShop }"
        data-auto-focus="false"
        data-dropdown
        data-hover="true"
        data-hover-pane="true">
        <div class="grid-x menu-pane">
          <div class="large-3 cell">
            <ul class="vertical-menu first">
              <li
                v-if="vueHeader.corporate.weAreRingana.titleDOM"
                class="category"
                :class="vueHeader.corporate.weAreRingana.titleClasses"
                v-html="vueHeader.corporate.weAreRingana.titleDOM"></li>
              <template v-if="vueHeader.corporate.weAreRingana.entries.length > 0">
                <template v-for="(entry, index) of vueHeader.corporate.weAreRingana.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-3-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-3 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.corporate.contact.titleDOM"
                class="category"
                :class="vueHeader.corporate.contact.titleClasses"
                v-html="vueHeader.corporate.contact.titleDOM"></li>
              <template v-if="vueHeader.corporate.contact.entries.length > 0">
                <template v-for="entry of vueHeader.corporate.contact.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
              <li
                v-if="(currentLanguage === 'de' || currentLanguage === 'en' || !currentLanguage) && vueHeader.corporate.jobs.titleDOM"
                class="category"
                :class="vueHeader.corporate.jobs.titleClasses"
                v-html="vueHeader.corporate.jobs.titleDOM"></li>
              <template v-if="vueHeader.corporate.jobs.entries.length > 0">
                <template v-for="entry of vueHeader.corporate.jobs.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.corporate.press.titleDOM"
                class="category"
                :class="vueHeader.corporate.press.titleClasses"
                v-html="vueHeader.corporate.press.titleDOM"></li>
              <template v-if="vueHeader.corporate.press.entries.length > 0">
                <template v-for="entry of vueHeader.corporate.press.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>

              <li
                v-if="vueHeader.corporate.media.titleDOM"
                class="category"
                :class="vueHeader.corporate.media.titleClasses"
                v-html="vueHeader.corporate.media.titleDOM"></li>
              <template v-if="vueHeader.corporate.media.entries.length > 0">
                <template v-for="(entry, index) of vueHeader.corporate.media.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-4-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.corporate.business.titleDOM"
                class="category"
                :class="vueHeader.corporate.business.titleClasses"
                v-html="vueHeader.corporate.business.titleDOM"></li>
              <template v-if="vueHeader.corporate.business.entries.length > 0">
                <template v-for="(entry, index) of vueHeader.corporate.business.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-5-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="large-2 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.corporate.businessRight.titleDOM"
                class="category"
                :class="vueHeader.corporate.businessRight.titleClasses"
                v-html="vueHeader.corporate.businessRight.titleDOM"></li>
              <template v-if="vueHeader.corporate.businessRight.entries.length > 0 && !partnerStatus">
                <template v-for="(entry, index) of vueHeader.corporate.businessRight.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-6-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
              <template
                v-if="vueHeader.corporate.businessRightPartnersAll.entries.length > 0
                  && partnerStatus
                  && (currentLanguage && currentLanguage === 'nl')">
                <template v-for="(entry, index) of vueHeader.corporate.businessRightPartnersAll.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-7-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
              <template
                v-if="vueHeader.corporate.businessRightPartnersAllDe.entries.length > 0
                  && partnerStatus
                  &&(!currentLanguage || currentLanguage !== 'nl')">
                <template v-for="(entry, index) of vueHeader.corporate.businessRightPartnersAllDe.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-8-${index}`"
                      class="subcategory"
                      :class="entry.classes">
                      <a :href="entry.link">{{ entry.linkName }}</a>
                    </li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <!--/ menu corporate-->
      <!--menu cn-->
      <div
        id="menuCnMenu"
        class="dropdown-pane"
        :class="{'dropdown-pane--partner-site': isPartnerShop }"
        data-auto-focus="false"
        data-dropdown
        data-hover="true"
        data-hover-pane="true">
        <!--customer menu -->
        <div
          v-if="!partnerStatus"
          class="grid-x menu-pane">
          <div class="cell auto">
            <ul class="vertical-menu first">
              <li
                v-if="vueHeader.myAccount.data.titleDOM"
                class="category"
                :class="vueHeader.myAccount.data.titleClasses"
                v-html="vueHeader.myAccount.data.titleDOM"></li>
              <template v-if="vueHeader.myAccount.data.length > 0">
                <template v-for="entry of vueHeader.myAccount.data.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="cell auto">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.myAccount.orders.titleDOM"
                class="category"
                :class="vueHeader.myAccount.orders.titleClasses"
                v-html="vueHeader.myAccount.orders.titleDOM"></li>
              <template v-if="vueHeader.myAccount.orders.length > 0">
                <template v-for="entry of vueHeader.myAccount.orders.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="cell auto">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.myAccount.account.titleDOM"
                class="category"
                :class="vueHeader.myAccount.account.titleClasses"
                v-html="vueHeader.myAccount.account.titleDOM"></li>
              <template v-if="vueHeader.myAccount.account.length > 0">
                <template v-for="entry of vueHeader.myAccount.account.entries">
                  <template v-if="entry.include">
                    <li
                      :key="entry.linkDOM"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="cell auto">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.myAccount.myPartner.titleDOM"
                class="category"
                :class="vueHeader.myAccount.myPartner.titleClasses"
                v-html="vueHeader.myAccount.myPartner.titleDOM"></li>
              <template v-if="vueHeader.myAccount.myPartner.length > 0">
                <template v-for="(entry, index) of vueHeader.myAccount.myPartner.entries">
                  <template v-if="entry.include">
                    <li
                      :key="`header-subcat-entry-9-${index}`"
                      class="subcategory"
                      :class="entry.classes"
                      v-html="entry.linkDOM"></li>
                  </template>
                </template>
              </template>
            </ul>
          </div>
          <div class="cell large-2">
            <ul class="vertical-menu">
              <li class="category no-sub logout">
                <span
                  class="logout"
                  data-cy="header-dropdown-logout"
                  @click.prevent="logout">Logout</span>
              </li>
            </ul>
          </div>
        </div>

        <!--partner menu -->
        <div
          v-if="partnerStatus"
          class="grid-x menu-pane">
          <div class="large-3 cell">
            <ul class="vertical-menu first">
              <li
                v-if="vueHeader.myAccountPartner.data.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.data.titleClasses"
                v-html="vueHeader.myAccountPartner.data.titleDOM"></li>
              <li
                v-if="vueHeader.myAccountPartner.orders.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.orders.titleClasses"
                v-html="vueHeader.myAccountPartner.orders.titleDOM"></li>
              <li
                v-if="vueHeader.myAccountPartner.account.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.account.titleClasses"
                v-html="vueHeader.myAccountPartner.account.titleDOM"></li>
              <li class="category no-sub logout ">
                <span
                  class="logout"
                  @click.prevent="logout">Logout</span>
              </li>
            </ul>
          </div>
          <div class="large-3 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.myAccountPartner.team.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.team.titleClasses"
                v-html="vueHeader.myAccountPartner.team.titleDOM"></li>
              <li
                v-if="vueHeader.myAccountPartner.partnerpage.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.partnerpage.titleClasses"
                v-html="vueHeader.myAccountPartner.partnerpage.titleDOM"></li>
              <li
                v-if="vueHeader.myAccountPartner.dates.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.dates.titleClasses"
                v-html="vueHeader.myAccountPartner.dates.titleDOM"></li>
            </ul>
          </div>
          <div class="large-3 cell">
            <ul class="vertical-menu">
              <li
                v-if="vueHeader.myAccountPartner.statistics.titleDOM"
                class="category"
                :class="vueHeader.myAccountPartner.statistics.titleClasses"
                v-html="vueHeader.myAccountPartner.statistics.titleDOM"></li>
              <li
                v-for="entry of vueHeader.myAccountPartner.statistics.entries"
                :key="entry.linkDOM"
                class="subcategory"
                :class="entry.classes">
                <a :href="entry.link">{{ entry.linkName }}</a>
              </li>
            </ul>
          </div>
          <div class="large-3 cell">
            <ul class="vertical-menu">
              <li
                class="category"
                :class="vueHeader.myAccountPartner.academy.titleClasses">
                <a :href="vueHeader.myAccountPartner.academy.titleDOM">Online Academy</a>
              </li>
              <li
                v-for="entry of vueHeader.myAccountPartner.academy.entries"
                :key="entry.link"
                class="subcategory"
                :class="entry.classes">
                <a :href="entry.link">
                  <img
                    v-if="entry.classes === 'menu-icon-home'"
                    alt=""
                    :src="icons.academyHome" />
                  <img
                    v-if="entry.classes === 'menu-icon-learning'"
                    alt=""
                    :src="icons.academyLearning" />
                  {{ entry.linkName }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Dashboard
      v-if="partnerStatus"
      :show-dashboard="showDashboard"
      @close-dashboard="toggleDashboard()" />
  </header>
</template>

<script>
  import PartnerShopMethods from "../../../methods/PartnerShopMethods";
  import MenuMethods from "../../../methods/MenuMethods";
  import THeaderData from "../../../types/THeaderData";
  import Dashboard from "../../dashboard/Dashboard";
  import CustomerHelper from "../../../helpers/CustomerHelper";
  import LocalStorageHelper from "../../../helpers/OldLocalStorageHelper";
  import DomEventHelper from "../../../helpers/DomEventHelper";

  export default {
    components: { Dashboard },
    data() {
      return THeaderData; /* not a deep clone - a reference. to we only have to load the data once! */
    },
    computed: {
      partnerDisplayName() {
        if(this.partnerShopInformation) {
          if(this.partnerShopInformation.firstname) {
            return this.partnerShopInformation.firstname;
          }
          if(this.partnerShopInformation.company) {
            return this.partnerShopInformation.company;
          }
        }
        return ``;
      },
    },
    mounted() {
      this.setUp();
      this.userStatus();
      window.$swal = this.$swal;
    },
    methods: {
      ...MenuMethods,
      ...PartnerShopMethods,
      removeNewNewsAmount() {
        LocalStorageHelper.removeNewNewsCount();
      },
      showCustomerMenu() {
        $(`#menuCnMenu`).addClass(`is-open`);
      },
      toggleSearchbox() {
        DomEventHelper.fireEvent({ name: `rin-searchbox-searchbar-toggled` });
      },
      userStatus() {
        // eslint-disable-next-line no-undef
        dataLayer.push({
          event: `userStatus`,
          isLoggedIn: CustomerHelper.getLoggedInState() !== false,
          isPartner: CustomerHelper.getPartnerStatus(),
        });
      },
    },
  };
</script>

<style lang="less">
  @import '../../../assets/styles/rin-variables';

  .rin-header {
    display: none;
  }

  .dashboardIcon {
    cursor: pointer;
    width: 20px;
  }

  .no-pad {
    padding: 0 !important;
  }

  .green-dot {
    background: @colorGreen;
    border-radius: 50%;
    display: inline-block;
    height: 10px;
    margin-left: 11px;
    width: 10px;
  }

  .new-news-amount {
    background: #fff;
    border-radius: 50%;
    color: @colorGreen;
    font-size: 13px;
    height: 26px;
    line-height: 24px;
    margin-left: 10px;
    margin-top: -1px;
    padding-left: 7px;
    position: absolute;
    width: 26px;

    @media (max-width: 1199px) {
      margin-left: 90px;
      margin-top: 12px;
    }
  }

  .menu {
    //remove when rethink over
    .top-bar__list-item.less-padding {
      a {
        padding: 20px 22px;

        @media (max-width: 1370px) {
          padding: 20px 20px;
        }

        @media (max-width: 1330px) {
          padding: 20px 17px;
        }

        @media (max-width: 1275px) {
          padding: 20px 13px;
        }
      }
    }

    .menu-dashboard {
      padding: 20px 0;
    }
  }

  .menu-search {
    &__search_icon {
      cursor: pointer;
      padding: 20px 15px 20px 20px;
    }
  }

  @media (min-width: 1200px) {
    .partnershop-topinfo-wrapper {
      background-color: #fff;
    }

    body.home .rin-header {
      display: block;
      position: absolute;
      top: 0;
      transition: top .34s linear;
      z-index: 1000;
    }

    .rin-header {
      display: block;
      width: 100%;

      &__currency {
        cursor: pointer;
        display: inline-block;
        padding: 5px 0;
      }

      .main-menu {
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: top .34s linear;

        &:hover {
          background-color: #fff;

          a:hover span:not(.basket-item-count) {
            border-bottom: 1px solid black;
            padding-bottom: 8px;
          }
        }

        &.search-active {
          top: 80px;
        }

        .dropdown-pane {
          background-color: rgba(0, 0, 0, .9);
          border: none;
          border-radius: 0;
          height: auto;
          left: 0 !important;
          padding: 40px 1rem 1rem 5.5rem;
          top: 100px !important;
          width: 100%;

          &--partner-site {
            .page-with-header & {
              top: 130px !important;
            }
          }

          &#menuShopDropdown {
            .subcategory a {
              letter-spacing: 2.5px;
              text-transform: uppercase;
            }
          }

          .category {
            list-style-type: none;
            padding-bottom: 5px;

            &.no-sub {
              padding-bottom: 35px;
            }

            &.no-sub.no-top {
              padding-top: 25px;
            }

            &.no-sub.has-span {
              display: inline-block;
            }

            a,
            span {
              color: #fff;
              cursor: pointer;
              letter-spacing: 2.5px;
              text-transform: uppercase;
            }

            img {
              height: 16px;
              padding-right: 10px;

              &.last-one {
                padding-left: 25px;
              }

              &.letter {
                height: 12px;
                vertical-align: baseline;
              }
            }
          }

          .subcategory {
            list-style-type: none;
            padding-bottom: 5px;

            &.is-top {
              padding-top: 30px;
            }

            a {
              color: #999;
            }
          }

          .menu-icon- {
            &home,
            &learning {
              img {
                height: 18px;
                padding-right: 15px;
              }
            }
          }

          #menu-teaser {
            padding-top: 8px;
            position: relative;

            .menu-teaser-text {
              font-family: @fontSemiBold;
              font-size: 1.3rem;
              left: 30px;
              line-height: 2rem;
              max-width: 300px;
              position: absolute;
              top: 30px;
            }

            img {
              height: 190px;
              width: 560px;
            }
          }

          a {
            font-size: 13px;
            letter-spacing: .5px;
          }
        }

        .main-menu-switch {
          display: inline-block;
          left: 20% !important;
          overflow: hidden;
          padding: 0;
          top: 100px !important;
          width: 80px;

          .vertical-menu {
            background-color: transparent;
            margin: 0;
            padding: 10px 0;

            .category {
              display: block;
              float: none;
              text-align: center;

              a {
                padding: 10px 0;
              }
            }
          }
        }

        .menu {
          align-items: center;
          display: none;
          flex-direction: row;
          height: 100%;

          @media (min-width: 780px) {
            display: flex;
          }
        }

        .menu-logo {
          display: flex;
          justify-content: center;

          img {
            padding: 30px 0;
            width: 105px;

            @media (max-width: 1200px) {
              width: 95px;
            }
          }
        }

        .partnershop-link {
          padding: 13px 0 10px 30px;
        }

        .partnershop-menuimage {
          border: 2px solid #fff;
          height: 35px;
          position: absolute;
          top: 44px;
          width: 35px;
        }

        .partnershop-menutext {
          display: inline-block;
          margin-left: 50px;
          max-width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .switches {
          &__element {
            padding: 20px 0;

            &.language-switch {
              &::after {
                content: '/';
                width: 15px;
              }
            }
          }
        }

        .top-bar {
          background-color: transparent;
          height: 100px;
          line-height: 100px;
          position: relative;

          @media (max-width: 1199px) {
            display: none;
          }

          &__list {
            background-color: transparent;
            font-size: .8rem;
            letter-spacing: 2px;
            list-style: none;
            text-transform: uppercase;

            &-item {
              float: left;
            }

            &.align-right {
              float: right;
            }
          }
        }

        .top-menu-container {
          width: 100%;
        }

        #menuCurrencySwitch {
          left: 40% !important;
        }

        #menuLanguageSwitch {
          left: 37% !important;
        }

        a {
          &#cnMenuLink {
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
